
const isDevMode = window.location.hostname === "localhost";

export const getShareUrl = (shareId) => {
  if(isDevMode) {
    return `localhost:3000/share/${shareId}`;
  }
  return `https://chat.cheap-gpt.app/share/${shareId}`;
}